// ----------------------------------------------------------------------
// <copyright file="StringUtilities.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * String utilities
 */
// TODO: test TOSRING
!(function() {
  const {
    toString,
    isNil,
    isEmpty,
    trim,
    toUpper,
    some,
    reject,
    join,
    flow,
    isUndefined,
    isNumber,
    escapeRegExp,
    map,
    includes,
    placeholder
  } = require('lodash/fp');
  const { EMPTY_GUID } = require('logic/data/Izenda.ReportsConstants');

  /**
   * Format string with parameters
   * @returns {String}
   */
  String.format = function() {
    // The string containing the format items (e.g. "{0}")
    // will and always has to be the first argument.
    var theString = arguments[0];

    if (theString === undefined || theString === '') {
      return theString;
    }

    // start with the second argument (i = 1)
    for (var i = 1; i < arguments.length; i++) {
      // "gm" = RegEx options for Global search (more than one instance)
      // and for Multi-line search
      var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
      theString = theString.replace(regEx, arguments[i]);
    }

    return theString;
  };

  String.formatDate = function(dateString) {
    if (!dateString) {
      return '';
    }

    var yyyy = dateString.substring(0, 4);
    var mm = dateString.substring(5, 7);
    var dd = dateString.substring(8, 10);

    return mm + '/' + dd + '/' + yyyy;
  };

  String.convertArrayOfStringToString = function(arr) {
    var result = '';
    if (!arr || arr.length === 0) {
      return result;
    }

    arr.forEach(function(element) {
      result += element;
    });

    return result;
  };

  String.isGuidFormat = function(arr) {
    var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;

    if (arr && regexGuid.test(arr)) {
      return true;
    }

    return false;
  };

  /**
   * Hash key to remove '[' , ']', '.' from id
   * Prevent error for jquery selector
   */
  String.hashKeyId = function(key) {
    return key.replace(/[\[\]\.]/g, '');
  };
  /**
   * Format number to string with int format
   * @param  {Int} number  Format number
   * @return {String}   Result
   */
  String.numberToString = function(number) {
    if (isNil(number) || !isNumber(number)) {
      return number;
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  String.decimalToString = function(number, decimalPlace) {
    if (isNil(number) || !isNumber(number)) {
      return number;
    }
    decimalPlace = decimalPlace || 1;
    return number.toFixed(decimalPlace).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  };

  /**
   * Date to String
   * @param  {[type]} date [description]
   * @return {[type]}     [description]
   */
  String.dateToString = function(date) {
    if (isNil(date)) {
      return date;
    }
    return date.toLocaleDateString();
  };

  /**
   * generate new name base on original name with number indicator to prevent duplicate
   * ex:
   *
   *    String.generateNewName('base',['base','test'],null,'()') -> 'base (2)'
   *    String.generateNewName('base',['base','test'],) -> 'base 2'
   *    String.generateNewName('base',[{name: 'base'}, {name: 'Test'}], get('name')) -> 'base 2'
   *
   * @param  {string} baseName        base name need to generate
   * @param  {Array} list               Array of string or object, if object must provide getStringFunction
   * @param  {func} getName           get property function  from object
   *                                    !optional if list is arra of string
   * @param  {string} numberContainer   container to wrap next number
   *                                    !optional
   * @return {string}                   unique new name
   */
  String.generateNewName = function(originalName, list, getName, numberContainer) {
    ensure(
      isEmpty(numberContainer) || typeof numberContainer === 'string',
      'number container character must be string or undefined'
    );

    var openCharacter = (!isEmpty(numberContainer) && numberContainer[0]) || '';
    var closeCharacter = (!isEmpty(numberContainer) && numberContainer[1]) || openCharacter;
    var esc = escapeRegExp;

    var regexString = String.format(
      '^{0}(?: {1}(\\d+){2})?$',
      esc(originalName),
      esc(openCharacter),
      esc(closeCharacter)
    );
    var regex = new RegExp(regexString, 'i');

    var extractNumber = function(item) {
      return parseInt(regex.exec(item)[1] || '1');
    };

    var nextNumber =
      (placeholder(list)
        .map(function(item) {
          return getName ? getName(item) : item;
        })
        .filter(function(item) {
          ensure(isNil(item) || typeof item === 'string', 'getStringFunction must return string');
          return item && regex.test(item);
        })
        .map(extractNumber)
        .max() || 0) + 1;

    return nextNumber === 1
      ? originalName
      : String.format('{0} {1}{2}{3}', originalName, openCharacter, nextNumber, closeCharacter);
  };

  /**
   * check duplicate base on getFn
   * @method checkDuplicate
   * @param  {string} baseName        base name need to generate
   * @param  {Array}  list            Array of string or object, if object must provide getStringFunction
   * @param  {func}   getFn           Get property function  from object
   *                                  !optional if list is arra of string
   * @return {boolean}                Check duplicate result
   */
  String.checkDuplicate = function(newText, existingCollection, getFn) {
    var upperText = trim(toUpper(newText));

    return some(function(item) {
      var itemData = getFn ? getFn(item) : item;

      ensure(isNil(itemData) || typeof itemData === 'string', 'only support string data');
      return trim(toUpper(itemData)) === upperText;
    }, existingCollection);
  };

  /**
   * Check value is pattern format
   * @param  {string}   value
   * @param  {regex}    pattern
   * @return {boolean}  result
   */
  String.isPatternFormat = function(value, pattern) {
    return pattern.test(value);
  };

  String.concatToUrl = function(args) {
    const slashPattern = /^\/+|\/+$/gm;
    const excludeEmpty = reject(isEmpty);
    const concatenateWithSlash = join('/');
    const trimSlash = map(function(part) {
      return part.replace(slashPattern, '');
    });

    return (
      '/' +
      flow(
        trimSlash,
        excludeEmpty,
        concatenateWithSlash
      )(args)
    );
  };

  /**
   * Convert rgb to hexColor
   * @param  {String} color val [description]
   * @return {[type]}          [description]
   */
  String.rgbToHex = function(color) {
    var HEX_VALUE = 16;
    var RGB_LENGTH = 3;

    var parts = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (isNil(parts)) return;
    delete parts[0];

    for (var i = 1; i <= RGB_LENGTH; i++) {
      parts[i] = parseInt(parts[i]).toString(HEX_VALUE);

      if (parts[i].length == 1) {
        parts[i] = '0' + parts[i];
      }
    }

    return '#' + parts.join('');
  };

  String.compareString = function(a, b, ignoreCase) {
    ignoreCase = isUndefined(ignoreCase) ? true : ignoreCase;

    if (ignoreCase) {
      return (a || '').toString().toLowerCase() === (b || '').toString().toLowerCase();
    }

    return a === b;
  };

  /**
   * search string
   * @param  {String} source
   * @param  {String} searchText
   * @param  {boolean} ignoreCase
   * @return {boolean} isMatched
   */
  String.searchString = function(source, searchText, ignoreCase) {
    if (!source || !searchText) {
      return false;
    }

    if (ignoreCase) {
      return includes(searchText.toLowerCase(), source.toLowerCase());
    }
    return includes(searchText, source);
  };

  String.replaceAt = function(source, index, length, newStr) {
    return source.substr(0, index) + newStr + source.substr(index + length);
  };

  /**
   * [truncateString description]
   * @param  {[type]} str [description]
   * @param  {[type]} num [description]
   * @return {[type]}     [description]
   */
  String.truncateString = function(str, num) {
    if (str.length <= num) {
      return str;
    } else {
      return str.slice(0, num) + '...';
    }
  };

  /**
   * Convert to string value
   * @param  {any} value
   * @param  {boolean} convertNullToEmpty
   * @return {string}
   */
  String.commonStringValue = function(value, convertNullToEmpty) {
    if (isNil(value) || isUndefined(value)) {
      return convertNullToEmpty ? '' : 'null';
    } else {
      return toString(value);
    }
  };

  /**
   * Check is guid empty
   * @param  {String}  value
   * @return {Boolean}
   */
  String.isEmptyGuid = function(value) {
    return value === EMPTY_GUID;
  };

  /**
   * Create guid string
   * @return {String}
   */
  String.newGuid = function() {
    function random4Digit() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return `${random4Digit()}${random4Digit()}-${random4Digit()}-${random4Digit()}-${random4Digit()}-${random4Digit()}${random4Digit()}${random4Digit()}`;
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.StringUtilities.js